<template>
    <div class="popup-update-bank-infos">
        <el-dialog :modelValue="true" width="480" customClass="flex-column" @close="$emit('close')">
            <template #title>
                <span class="fs-5 bold">{{
                    $t.__('Mise à jour des informations bancaires')
                }}</span>
            </template>
            <div>
                <div>
                    <p class="pb-1">
                        {{ $t.__('Liste des comptes bancaires') }}
                    </p>
                    <el-select
                        ref="selectbankAccount"
                        class="wp-10"
                        v-model="selectedLabel"
                        :placeholder="$t.__('Comptes bancaires')"
                        @change="onSelectChange"
                    >
                        <el-option
                            v-for="account in accountsAvailable"
                            :key="account.id"
                            :label="account.label + ' : ' + account.name"
                            :value="account.id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <CompassButton
                        :label="$t.__('Annuler')"
                        type="secondary"
                        @click="$emit('close')"
                    />
                    <CompassButton
                        :label="$t.__('Enregistrer')"
                        type="primary"
                        :disabled="selectedLabel === ''"
                        @click="save()"
                    />
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import FormMixins from '../../mixins/FormMixins';

export default {
    mixins: [FormMixins],
    props: {
        rows: {
            type: Array,
            default() {
                return [];
            },
        },
        emitEditSuccess: {
            type: String,
            required: false,
            default: 'listing:refresh',
        },
    },
    data() {
        return {
            selectedLabel: '',
            selectedBankAccount: null,
            accountsAvailable: [],
        };
    },
    created() {
        this.$emit('updateLoading', { loading: true });
        Promise.all([this.getBankAccount()]).then(
            (values) => {
                this.accountsAvailable = values[0];

                this.$emit('updateLoading', { loading: false });
            },
            () => {
                this.$emit('updateLoading', { loading: false });
                Push.error($t.__('Problème lors de la récupération des données'));
                this.$emit('close');
            },
        );
    },
    methods: {
        onSelectChange(selectedValue) {
            this.selectedBankAccount = this.accountsAvailable.find(
                (account) => account.id === selectedValue,
            );
        },
        async save() {
            const payload = {
                model_ids: [],
                account_bank_id: null,
            };
            this.populatePayload(payload);
            this.formatPayload(payload);

            const bankAccountData = this.selectedBankAccount;

            if (!bankAccountData) {
                Push.error($t.__('Veuillez sélectionner un compte bancaire.'));
                return;
            }

            payload.account_bank_id = bankAccountData.id;
            this.$ajax.put(
                '/rest/bankaccount/batch/update/info',
                {},
                _.toPlainObject(payload),
                () => {
                    EventBus.emit(this.emitEditSuccess);
                    this.$emit('close');
                    Push.success($t.__('Modification effectuée.'));
                },
                (error) => {
                    Push.error(
                        error?.response?.data?.error?.message ??
                            $t.__('Une erreur est survenue lors du traitement.'),
                    );
                },
            );
        },
        populatePayload(payload) {
            payload.model_ids = this.rows;
        },
        formatPayload(payload) {
            payload.model_ids = payload.model_ids.map((modelID) => {
                return modelID.replace('model_', '');
            });
        },
        getBankAccount() {
            return new Promise((resolve, reject) => {
                this.$ajax.post(
                    `/rest/bankaccount`,
                    {},
                    {
                        displayOnlyBankAccountWithBalance: false,
                        displayOnlyBankAccountEnabled: true,
                    },
                    (response) => {
                        response.error ? reject() : resolve(response);
                    },
                    () => {
                        reject();
                    },
                );
            });
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.popup-update-bank-infos {
    div > p > i {
        cursor: pointer;
    }

    .el-dialog__wrapper .el-dialog.flex-column {
        max-height: 800px;
        border-radius: 4px;

        .el-dialog__header {
            padding-bottom: 24px;

            button i {
                color: $gray-100;
            }
        }
    }
}
</style>
